import "regenerator-runtime/runtime";
import { all, fork } from "redux-saga/effects";
import * as ssoSaga from "./ssoSaga";
import headerSaga from "./headerSaga";
import dashboardSaga from "./dashboardSaga";
import errorSaga from "./errorSaga";
import commonSaga from "./commonSaga";
import portalSaga from "./PortalSaga";
import epicSaga from "./epicSaga";
import videoVisitSaga from "./videoVisitSaga";

// register watcher saga(s) and export a single generator function as the root saga.
export default function* startForeman() {
    // sagas needed by all bundles
    let watchers = [
        fork(ssoSaga.watchUserAuthenticate),
        fork(headerSaga),
        fork(errorSaga),
        fork(commonSaga),
        fork(portalSaga),
        fork(dashboardSaga),
        fork(epicSaga),
        fork(videoVisitSaga)
    ];

    try {
        yield all(watchers);
    }
    catch (err) {
        //debugger;
        console.error(err);
    }
}